export default __webpack_public_path__ + "static/media/cover-1.524b8a25.jpg";